'use client';

import React, { useEffect, useState } from 'react';

import ListingPageFilterComponent from './ListingPageFilterComponent';

export default function CollegeListingPageFilter({ geoLocation, filterData, filterSecStreamData }: any) {
  const [isShow, setIsShow] = useState(false);
  useEffect(() => {
    if (geoLocation && filterData && filterSecStreamData) {
      setIsShow(true);
    } else setIsShow(false);
  }, [geoLocation, filterData, filterSecStreamData]);

  if (!isShow) {
    return <div className="size-full"></div>;
  }
  return (
    <ListingPageFilterComponent
      geoLocation={geoLocation}
      filterData={filterData}
      filterSecStreamData={filterSecStreamData}
    />
  );
}
